import styled from 'styled-components';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const ImageGalleryStyles = styled.div`
  .image-gallery {
    margin-top: -25px;
    margin-left: -8%;
    margin-right: -8%;

    .aspect-image {
      img {
        transform: translate(0%, 0%);
      }
    }

    .card-info-area {
      visibility: hidden;
    }

    .card-image-area {
      border-radius: 0px;
    }

    .carousel-root .carousel {
      border-radius: 0px;
    }

    .single {
      .image-gallery-card {
        width: 100%;
        max-height: 480px;
      }
      margin-bottom: 5px;
    }

    .quad {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 5px;
      justify-content: space-between;

      .image-gallery-card {
        width: calc(50% - 3px);
        /* height: 239px; */
      }
      .quad-img {
        height: 239px;
      }
    }

    @media only screen and (min-width: ${desktop_breakpoint}px) {
      margin-top: 0;
      margin-left: 0;
      margin-right: 0;
      max-width: 100%;
      position: relative;
    }
  }

  .tour-modal {
    .modal-container {
      width: 100%;
      height: 100%;
      top: 49.9% !important;

      .close-modal {
        top: 2%;
        left: calc(100% - 8%);
        z-index: 9;
      }

      .close-modal svg {
        background-color: ${Colors.primary.white.standard};
        path {
          fill: ${Colors.primary.black.standard} !important;
        }
      }

      .modal-content {
        height: 100%;
        max-height: 99vh;
      }

      @media only screen and (min-width: ${desktop_breakpoint}px) {
        .close-modal {
          top: 2%;
          left: calc(100% - 14%);
          z-index: 9;
        }
      }

      @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
        .close-modal {
          top: 2%;
          left: calc(100% - 12%);
          z-index: 9;
        }
      }
    }
  }

  .image-gallery-card {
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .overlay-viewall {
      cursor: pointer;
      position: absolute;
      width: 100%;
      height: 100%;
      background: ${Colors.primary.black.standard};
      opacity: 0.8;
      top: 0;

      div {
        color: ${Colors.primary.white.standard};
        text-decoration: none;
        position: absolute;
        top: 45%;
        left: 40%;

        svg {
          margin-left: 0.3em;
          position: absolute;
          top: calc(50% - 14px);
          transition: all 0.1s ease-in-out 0s;
          transform: translateY(40%);

          path {
            fill: ${Colors.primary.white.standard};
          }
        }
      }
      &:hover {
        svg {
          transform: translate(30%, 40%);
        }
      }
    }
  }
`;
